var map = {
	"./betting-virtualf-games-holder-bar.png": 1983,
	"./btn-background-black.png": 280,
	"./btn-background-green.png": 281,
	"./fast-choosen-bck.png": 282,
	"./next-bck.png": 138,
	"./vdh-progress.png": 283,
	"./video/clubs/england/arsenal.png": 284,
	"./video/clubs/england/chelsea.png": 285,
	"./video/clubs/england/liverpool.png": 286,
	"./video/clubs/england/m-city.png": 287,
	"./video/clubs/england/m-united.png": 288,
	"./video/clubs/france/bordeaux.png": 289,
	"./video/clubs/france/lille.png": 290,
	"./video/clubs/france/lyon.png": 291,
	"./video/clubs/france/marseille.png": 292,
	"./video/clubs/france/psg.png": 293,
	"./video/clubs/germany/bayern.png": 294,
	"./video/clubs/germany/dortmund.png": 295,
	"./video/clubs/germany/hertha.png": 296,
	"./video/clubs/germany/leverkusen.png": 297,
	"./video/clubs/germany/schalke04.png": 298,
	"./video/clubs/italy/inter.png": 299,
	"./video/clubs/italy/juventus.png": 300,
	"./video/clubs/italy/lazio.png": 301,
	"./video/clubs/italy/milan.png": 302,
	"./video/clubs/italy/roma.png": 303,
	"./video/clubs/spain/atletico-bilbao.png": 304,
	"./video/clubs/spain/atletico-madrid.png": 305,
	"./video/clubs/spain/barcelona.png": 306,
	"./video/clubs/spain/real-madrid.png": 307,
	"./video/clubs/spain/valencia.png": 308,
	"./video/result-logo.png": 1984,
	"./video/result-score.png": 309,
	"./video/video-bck.png": 310,
	"./video/video-header-bck.png": 311,
	"./video/video-jackpot.png": 312,
	"./video/video-mega-jackpot.png": 313,
	"./video/virtualf-logo.png": 1985,
	"./video/vvb-body-bot.png": 314,
	"./video/vvb-body-top.png": 315,
	"./video/vvb-header.png": 316,
	"./virtualf-video.png": 1986
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1982;


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img \.(gif|png|jpe?g|svg)$/
// module id = 1982
// module chunks = 6